import CUSTOM_SECTION_TYPE from '@src/quince-site-common/src/domains/CustomSectionType'
import BundlePageSectionProps from '@src/quince-site-pdp/src/domains/BundlePageSectionProps'

import BundleProductPurchase from '../../organisms/productPageSections/bundleProductPurchase/BundleProductPurchase'
import { ProductSectionType } from '../../types/productPage.types'
import {
  SECTION_TYPES_VS_RENDERER as PRODUCT_SECTION_TYPES_VS_RENDERER,
  CUSTOM_SECTION_TYPES_VS_RENDERER as PRODUCT_CUSTOM_SECTION_TYPES_VS_RENDERER,
} from '../productPage/productPage.constants'

export const SECTION_TYPES_VS_RENDERER: Record<string, (props: BundlePageSectionProps) => JSX.Element | null> = {
  ...PRODUCT_SECTION_TYPES_VS_RENDERER,
  [ProductSectionType.BUNDLE_PRODUCT_IMAGES_AND_PURCHASE]: BundleProductPurchase,
}

export const CUSTOM_SECTION_TYPES_VS_RENDERER: Partial<
  Record<CUSTOM_SECTION_TYPE, undefined | ((props: BundlePageSectionProps) => JSX.Element | null)>
> = {
  ...PRODUCT_CUSTOM_SECTION_TYPES_VS_RENDERER,
}
